export const searchQueryKeyMap = {
  projects: (params?: object) =>
    ['projects', params].filter((item) => item !== undefined),
  projectAnalysis: (params?: object) =>
    ['projectAnalysis', params].filter((item) => item !== undefined),
};
